/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable no-negated-condition */
/* eslint-disable react/jsx-key */
/* eslint-disable quotes */
import React, { Component } from "react"
import { Button, Modal } from "react-bootstrap"
import GetContent from "../../Services/Queries/GetContent"
import Content from "../content"
import { Auth } from "aws-amplify"

export default class EditContent extends Component {
	constructor(props) {
		super(props)
		this.state = {
			contentDetails: {},
			isNewLang: false,
			contentID: "",
			languageModalVisible: false,
			contentLanguageOptions: [
				{
					label: "English",
					value: "En",
					id: 0,
				},
				{
					label: "Telugu",
					value: "Te",
					id: 1,
				},
			],
			contentSelectedLangVal: null,
			editContent: false,
		}
	}

	handleContentID = e => {
		const contentID = e.target.value
		this.setState({ contentID })
	}

	openContentLanguagesModal = async () => {
		const input = {
			appInfoFrontEnd: {
				UUID: Auth.user.username,
				appVersionNumber: 62,
			},
			contentID: this.state.contentID,
		}
		console.log(input, "inputaaaaa")
		const data = await GetContent(input)
		console.log(data, "dataaaaaa")
		if (data.contentLanguages && data.contentLanguages.length == 1) {
			this.setState({ contentSelectedLangVal: data.contentLanguages[0] })
		}

		this.setState({ contentDetails: data, languageModalVisible: true })
	}

	closeModal = () => {
		this.setState({ languageModalVisible: false })
	}

	changeContentLanguage = lang => {
		const contentLangs =
			this.state.contentDetails && this.state.contentDetails.contentLanguages
				? this.state.contentDetails.contentLanguages
				: []
		const isLangCreated = contentLangs.includes(lang)
		this.setState({ contentSelectedLangVal: lang, isNewLang: !isLangCreated })
	}

	editContent = () => {
		this.setState({ editContent: true, languageModalVisible: false })
	}

	componentDidMount = () => {
		const urlParams = window.location.href.split("?")
		if (urlParams && urlParams[1]) {
			this.setState({ contentID: "cont#" + urlParams[1] }, async () => {
				const input = {
					appInfoFrontEnd: {
						UUID: Auth.user.username,
						appVersionNumber: 62,
					},
					contentID: this.state.contentID,
				}
				const data = await GetContent(input)
				if (data.contentLanguages && data.contentLanguages.length == 1) {
					this.setState({
						contentSelectedLangVal: data.contentLanguages[0],
						contentDetails: data,
						editContent: true,
					})
				}
			})
		}
	}

	render() {
		const {
			contentID,
			languageModalVisible,
			contentLanguageOptions,
			contentSelectedLangVal,
			contentDetails,
		} = this.state
		return (
			<div className=' row col-md-12'>
				<label htmlFor='text'>Content ID</label>
				<div>
					<input
						type='text'
						onChange={value => {
							this.handleContentID(value)
						}}
						value={this.state.contentID}
						placeholder='Please Enter ContentID'
					></input>
				</div>
				<Modal show={languageModalVisible} onHide={() => this.closeModal()}>
					<Modal.Body>
						<div className='row'>
							{contentLanguageOptions.map(language => (
								<div>
									<input
										value={contentSelectedLangVal}
										type='radio'
										checked={
											this.state.contentSelectedLangVal == language.value
										}
										onClick={() => {
											this.changeContentLanguage(language.value)
										}}
									></input>
									<text htmlFor={language.label}>{language.label}</text>
									{contentDetails &&
										contentDetails.contentLanguages &&
										contentDetails.contentLanguages.includes(language.value) ? (
										<text htmlFor='available'>(available)</text>
									) : (
										<text htmlFor='unavailable'>(unavailable)</text>
									)}
								</div>
							))}
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={() => this.closeModal()}>Cancel</Button>
						<Button onClick={() => this.editContent()}>Ok</Button>
					</Modal.Footer>
				</Modal>
				{!this.state.contentID ? (
					<div>
						<text htmlFor='text' style={{ color: "red", fontSize: 10 }}>
							Content ID cannot be empty
						</text>
						<div>
							<Button disabled variant='secondary'>
								Edit Content
							</Button>
						</div>
					</div>
				) : null}
				{this.state.contentID ? (
					<div>
						<Button
							onClick={() => this.openContentLanguagesModal()}
							variant='primary'
						>
							Edit Content
						</Button>
					</div>
				) : null}
				{this.state.contentSelectedLangVal && this.state.editContent ? (
					<Content
						isNewLang={this.state.isNewLang}
						editContent={true}
						contentSelectedLangVal={this.state.contentSelectedLangVal}
						contentDetails={this.state.contentDetails}
					/>
				) : null}
			</div>
		)
	}
}
